export const setCurrentForm = ({ commit }, val) => {
    commit('setCurrentForm', val);
}